<section class="hero-section">

    <div class="container">

        <div class="row justify-content-center">

            <div class="col-xl-10 text-center">

                <span class="badge bg-primary mb-4">
                    Trusted Business & Professional Network
                </span>

                <h1 class="hero-title mb-4">
                    Connecting
                    <span class="text-primary">
                        SONI Professionals
                    </span>,
                    Entrepreneurs &
                    Business Owners
                </h1>
                <p class="hero-description mx-auto mb-5">
                    Discover opportunities, exchange referrals,
                    build partnerships, find mentors, and grow through a
                    trusted community built exclusively for the Soni ecosystem.
                </p>

                <div class="d-flex justify-content-center gap-3 flex-wrap mb-5">

                    <button class="btn btn-primary btn-hero" [routerLink]="'/auth/join'">
                        Join SoniBiz
                    </button>

                    <button class="btn btn-outline-primary btn-hero">
                        Learn More
                    </button>

                </div>

            </div>

        </div>



    </div>

</section>